import { render, staticRenderFns } from "./OnboardingBackdoc.vue?vue&type=template&id=1ca43345&scoped=true"
import script from "./OnboardingBackdoc.vue?vue&type=script&lang=js"
export * from "./OnboardingBackdoc.vue?vue&type=script&lang=js"
import style0 from "./OnboardingBackdoc.vue?vue&type=style&index=0&id=1ca43345&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca43345",
  null
  
)

export default component.exports